import { createApp } from 'vue'
import StreamDonationOverviewPreviousDonation from './StreamDonationOverviewPreviousDonation'

const el = '.kb-component--stream-donation-overview-previous-donation'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StreamDonationOverviewPreviousDonationDOM) => {
            const component = createApp(StreamDonationOverviewPreviousDonation).use(Store)
            component.mount(StreamDonationOverviewPreviousDonationDOM)
        })
    }
}
